import { actionTypes } from '@/services/actions/settings/user';

const initialState = {
  users: [],
  usersForApiKey: [],
  error: false,
  loading: false,
};

const userManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload.data,
        usersForApiKey: action.payload.dataApiKey,
      };
    case actionTypes.ADD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        users: [...state.users, action.payload],
      };
    case actionTypes.DELETE_USER_SUCCESS:
    case actionTypes.UPDATE_USER_SUCCESS:
    case actionTypes.SET_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default userManagementReducer;
